// extracted by mini-css-extract-plugin
export default {"link":"PE-z","disabled":"QE-z"};